<template>
  <div>
    <aha-icon-button
      :variant="'tertiary'"
      @click="onNewSlideButtonClicked"
      @keydown.enter="onNewSlideButtonClicked"
      @keydown.space="onNewSlideButtonClicked"
      name="side-left-new-slide-button"
      v-aha-emit-action
    >
      <aha-icon
        name="plus-new"
        height="16"
        width="16"
        viewBox="0 0 16 16"
      />
      <p class="ml-2">
        {{ $i18nPresenter.t('New slide') }}
      </p>
    </aha-icon-button>
  </div>
</template>

<script>
export default {
  methods: {
    onNewSlideButtonClicked() {
      this.$emit('addNewSlide')
    },
  },
}
</script>
